import React, { FC } from "react";
import { CsobQuestionAnswerDto } from "@green0meter/api-client";

import { HighlightText } from "../HighlightText";

import { Box, Typography } from "@components/base";

interface InputBoxValue {
  answer: CsobQuestionAnswerDto;
  answerIndex: "answer1" | "answer2";
}

const COLOR_SECONDARY = "rgb(0 0 0 / 50%)";

export const InputBoxValue: FC<InputBoxValue> = ({ answer, answerIndex }) => {
  const { unit } = answer;
  const value = answer[answerIndex] || "";

  return (
    <Box
      flex={1}
      maxWidth={288}
      paddingX={2}
      height={44}
      borderRadius={1.2}
      bgcolor="#F5F5F5"
      border="2px solid #E9E9E9"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        opacity: value ? 1 : 0.5,
      }}
    >
      <Box display="flex" flexDirection="column">
        <HighlightText isHighlighted={answer.answer1 !== answer.answer2}>
          {value}
        </HighlightText>
      </Box>
      {unit && (
        <Typography fontSize={14} color={COLOR_SECONDARY}>
          {unit}
        </Typography>
      )}
    </Box>
  );
};
